import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Layers, Check } from 'lucide-react';
export function Slide6Pricing() {
  const ladder = [{
    level: '1 use case',
    desc: 'Standard pilot price',
    height: 'h-16',
    width: 'w-1/4',
    color: 'bg-gray-200'
  }, {
    level: '2 use cases',
    desc: 'Reuse discount applied',
    height: 'h-24',
    width: 'w-2/4',
    color: 'bg-gray-300'
  }, {
    level: '3 use cases',
    desc: 'Larger reuse discount applied',
    height: 'h-32',
    width: 'w-3/4',
    color: 'bg-gray-400'
  }, {
    level: '4+ use cases',
    desc: 'Packaged congress journey pricing',
    height: 'h-40',
    width: 'w-full',
    color: 'bg-[#E60012]'
  }];
  const components = ['Strategic congress journey framework', 'Creative concept and visual system', 'Hook GIF design', 'Quiz and poll mechanics', 'Approved copy modules', 'Snak interface components', 'Reporting structure', 'Dashboard setup', 'Channel-specific adaptations'];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-192">
      <header className="mb-10" data-id="element-193">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-194">
          One use case can stand alone.{' '}
          <span className="text-[#E60012]" data-id="element-195">
            Several use cases can share components.
          </span>
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-196">
          The more use cases Takeda selects, the more strategy, design, logic
          and reporting can be reused.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-16 items-end" data-id="element-197">
        {/* Ladder */}
        <div className="flex flex-col justify-end h-full pb-8" data-id="element-198">
          <div className="flex items-end gap-2 h-64" data-id="element-199">
            {ladder.map((step, index) => <motion.div key={step.level} className={`relative flex-1 flex flex-col justify-end rounded-t-lg ${step.color} group`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: '100%',
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2 + index * 0.15
          }} style={{
            height: `${(index + 1) * 25}%`
          }} data-id="element-200">
                <div className="p-4 text-center" data-id="element-201">
                  <div className={`font-bold text-sm ${index === 3 ? 'text-white' : 'text-[#1A202C]'}`} data-id="element-202">
                    {step.level}
                  </div>
                  <div className={`text-xs mt-1 opacity-0 group-hover:opacity-100 transition-opacity absolute -top-12 left-1/2 -translate-x-1/2 w-max bg-white px-3 py-2 rounded shadow-lg border border-gray-100 z-10 text-[#2D3748]`} data-id="element-203">
                    {step.desc}
                  </div>
                </div>
              </motion.div>)}
          </div>
          <div className="h-1 w-full bg-gray-200 rounded-full mt-2" data-id="element-204" />
          <motion.p className="text-center mt-6 text-[#E60012] font-semibold" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1
        }} data-id="element-205">
            The price per use case decreases when several use cases are built
            from the same campaign logic.
          </motion.p>
        </div>

        {/* Reusable Components */}
        <motion.div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 h-full flex flex-col" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-206">
          <div className="flex items-center gap-3 mb-6" data-id="element-207">
            <Layers className="w-6 h-6 text-[#6B46C1]" data-id="element-208" />
            <h3 className="text-xl font-bold text-[#1A202C]" data-id="element-209">
              Reusable components may include:
            </h3>
          </div>

          <div className="grid grid-cols-1 gap-4 flex-1" data-id="element-210">
            {components.map((comp, i) => <motion.div key={i} className="flex items-center gap-3" initial={{
            opacity: 0,
            x: 10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.8 + i * 0.05
          }} data-id="element-211">
                <div className="w-5 h-5 rounded-full bg-[#E60012]/10 flex items-center justify-center shrink-0" data-id="element-212">
                  <Check className="w-3 h-3 text-[#E60012]" data-id="element-213" />
                </div>
                <span className="text-[#4A5568] text-sm" data-id="element-214">{comp}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </main>
    </div>;
}